import request from '@/utils/request'

const BASE_URL = process.env.VUE_APP_API_BASE_URL


export async function getOrderDetail(data){
    return request({
        url: `${BASE_URL}/api/v1/cashier/get_detail`,
        method: 'get',
        data
    })
}

export async function getPayInfo(data){
    return request({
        url: `${BASE_URL}/api/v1/cashier/get_pay_info`,
        method: 'post',
        data
    })
}

export async function searchOrder(data){
    return request({
        url: `${BASE_URL}/api/v1/cashier/search_order`,
        method: 'get',
        data
    })
}
